var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('epi-picture',{directives:[{name:"edit",rawName:"v-edit",value:('Image'),expression:"'Image'"}],attrs:{"slot":"media","image":_vm.adaptiveImage,"float-setting":_vm.floatSetting,"sharpen":80,"auto-quality":"best"},slot:"media"})}
var staticRenderFns = []

export { render, staticRenderFns }